

















































































import FlightSaleChannel from "@/store/entities/flight/flightSaleChannel";
import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class AddSalesChannel extends Vue {
  isValid: boolean = false;
  dialog: boolean = true;
  isEdit: boolean = false;
  flightSaleChannel: FlightSaleChannel = new FlightSaleChannel();

  data() {
    return {
      title: "Preliminary report",
      email: "",
      rules: {
        required: (value) => !!value || "Zorunlu Alan.",
      },
    };
  }

  created() {
    this.flightSaleChannel = this.$store.state.flightSaleChannel.editFlightSaleChannel;
    if (this.flightSaleChannel == null) {
      this.isEdit = false;
      this.flightSaleChannel = new FlightSaleChannel();
    } else {
      this.isEdit = true;
    }
  }

  async saveFlightSaleChannel() {
    if (!this.isEdit) {
      await this.$store.dispatch({
        type: "flightSaleChannel/saveFlightSaleChannel",
        data: this.flightSaleChannel,
      });

      Vue.$toast.success("Kayıt Eklendi");
      this.closeDialog();
    } else {
      await this.$store.dispatch({
        type: "flightSaleChannel/saveFlightSaleChannel",
        data: this.flightSaleChannel,
      });

      Vue.$toast.success("Kayıt Güncellendi");

      this.closeDialog();
    }
  }
  closeDialog() {
    this.$emit("closed");
  }

  cancelDialog() {
    this.$emit("cancel");
    this.$store.state.flightSaleChannel.editFlightSaleChannel = null;
  }
}
